import { useEffect, useState } from 'react';
import { settingsApi } from '../../api';

import type {
    Notification,
    NotificationOrNull,
    NotificationType,
} from './PortalNotification.types';

const fetchNotification = async (portal: NotificationType) => {
    try {
        const notif = (await settingsApi.get(`/notifications?portal=${portal}`)) as Notification[];
        return Array.isArray(notif) ? notif[0] : null;
    } catch {
        return null;
    }
};

export function useFetchPortalNotifications({
    enabled,
    portal,
}: { enabled: boolean; portal: NotificationType }) {
    const [notification, setNotification] = useState<NotificationOrNull>(null);

    useEffect(() => {
        if (enabled) {
            fetchNotification(portal).then(notif => {
                setNotification(notif);
            });
        }
    }, [enabled, portal]);

    return notification;
}
